import Vue from 'vue';
// const ENDPOINT = `https://nominatim.openstreetmap.org/reverse`;
// const FORMAT = `jsonv2`;

export function currentCoordinates() {
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
            ({ coords }) => resolve(coords),
            error => reject(error),
            {enableHighAccuracy: true}
        );
    });
}

export async function addressByCoordinates({ latitude, longitude }) {
    // eslint-disable-next-line no-undef
    const geocoder = new google.maps.Geocoder();
    
    const data = await geocoder
        .geocode({
            location: {
                lat: latitude,
                lng: longitude
            }
        })
        .then((response) => {
            if (response.results[0]) {
                return response.results[0];
            }
        });

    const endereco = tratarEnderecoGoogle(data.address_components);

    const address = {
        logradouro: Vue.prototype.$func.substituiVazio(endereco.logradouro, '-'),
        numero: '',
        bairro: Vue.prototype.$func.substituiVazio(endereco.bairro, '-'),
        cidade: Vue.prototype.$func.substituiVazio(endereco.cidade, '-'),
        estado: Vue.prototype.$func.substituiVazio(endereco.estado, '-'),
        referencia: '',
        latitude: Vue.prototype.$func.substituiVazio(data.geometry.location.lat(), '-'),
        longitude: Vue.prototype.$func.substituiVazio(data.geometry.location.lng(), '-')
    }

    return address;
}

export async function currentAddress() {
    const coordinates = await currentCoordinates();
    return addressByCoordinates(coordinates);
}

function tratarEnderecoGoogle(address) {
    let logradouro = '';
    let bairro = '';
    let cidade = '';
    let estado = '';
    
    const posicoesLogradouro = ['street_address', 'road', 'route'];
    const posicoesBairro = ['sublocality_level_1', 'administrative_area_level_4', 'neighbourhood'];
    const posicoesCidade = ['administrative_area_level_2', 'administrative_area_level_2', 'locality', 'city_district', 'city', 'town'];
    const posicoesEstado = ['state', 'administrative_area_level_1'];
    
    address.forEach((item) => {
        if (posicoesLogradouro.includes(item.types[0])) {
            logradouro = item.long_name;
        }
        if (posicoesBairro.includes(item.types[0])) {
            bairro = item.long_name;
        }
        if (posicoesCidade.includes(item.types[0])) {
            cidade = item.long_name;
        }
        if (posicoesEstado.includes(item.types[0])) {
            estado = item.long_name;
        }
    });

    return { logradouro, bairro, cidade, estado };
}